import * as React from 'react';
import Avatar from '@mui/material/Avatar';

import { CONFIG } from "../../Config"


const Footer = () => {

    return (
        <div className="footerContainer" >
            <img
                alt="Im Logo"
                src={CONFIG.LOGO}
                className="footerLogo"


            />
        </div>

    )
}

export default React.memo(Footer);